import Indicator from "components/indicator";
import { ColumnInterface } from "components/tables/interfaces";
import Table from "components/tables/table";
import { timestamp } from "lib/date";
import { Admin } from "models/admin";
import { Fragment, FunctionComponent, useEffect, useState } from "react";
import { adminDoGetAdmins } from "services/admin/admin";
import AddAdminModal from "./add-admin-modal";
import EditAdminModal from "./edit-admin-modal";
import { faUserShield } from "components/icon-library";
import AccessModal from "./access-modal";
import { useAuthAdmin } from "stores/hooks/auth";

interface AdminsTableProps {}

const AdminsTable: FunctionComponent<AdminsTableProps> = ({}) => {
  const currentAdmin = useAuthAdmin();
  const [admins, toggleAdmins] = useState<Admin[]>([]);
  const [addModal, toggleAddModal] = useState(false);
  const [editModal, toggleEditModal] = useState<Admin | undefined>(undefined);
  const [accessModal, toggleAccessModal] = useState<Admin | undefined>(
    undefined,
  );

  const update = async () => {
    // get configuration
    const admins = await adminDoGetAdmins();
    toggleAdmins(admins);
  };

  useEffect(() => {
    update();
  }, []);

  const columns: ColumnInterface[] = [
    {
      key: "name",
      header: "Nimi",
      width: 175,
      render: (admin: Admin) => `${admin.firstname} ${admin.lastname}`,
    },
    {
      key: "email",
      header: "Sähköposti",
      render: (admin: Admin) => admin.email,
    },
    {
      key: "org_admin",
      header: "Pääsyoikeustaso",
      width: 225,
      render: (admin: Admin) => {
        const { active, org_admin } = admin;
        if (active === false) {
          return <Indicator type="negative">Ei pääsyä</Indicator>;
        }
        if (org_admin) {
          return <Indicator type="positive">Luettelot ja asetukset</Indicator>;
        }
        return <Indicator type="positive">Luettelot</Indicator>;
      },
    },
    {
      key: "last_login",
      header: "Viimeksi kirjautunut",
      width: 220,
      render: (admin: Admin) =>
        admin.last_login_at ? timestamp(admin.last_login_at) : "",
    },
  ];

  const onAdd = async () => toggleAddModal(true);

  return (
    <Fragment>
      <Table
        name="admins"
        columns={columns}
        data={admins}
        adder={{
          text: "Uusi ylläpitäjä",
          onClick: onAdd,
          isDisabled: () => false,
        }}
        editers={[
          {
            onClick: async (admin) => toggleAccessModal(admin),
            icon: faUserShield,
            isDisabled: (admin) => admin.uuid === currentAdmin?.uuid,
          },
          { onClick: async (admin) => toggleEditModal(admin) },
        ]}
      />
      {addModal && (
        <AddAdminModal
          onUpdate={update}
          onClose={async () => toggleAddModal(false)}
        />
      )}
      {editModal && (
        <EditAdminModal
          admin={editModal}
          onUpdate={update}
          onClose={async () => toggleEditModal(undefined)}
        />
      )}
      {accessModal && (
        <AccessModal
          admin={accessModal}
          onUpdate={update}
          onClose={async () => toggleAccessModal(undefined)}
        />
      )}
    </Fragment>
  );
};

export default AdminsTable;
